import api from '../../../../api';

export const SearchSelector = {
  SEARCH_BAR: api.internals.ns.selector('search-bar')
};
